const themeControllerInputs = document.querySelectorAll<HTMLInputElement>('.theme-controller');

// Parse the theme options from the HTML element
const optionsElement = document.documentElement.getAttribute('data-theme-options');
const options = optionsElement ? JSON.parse(optionsElement) : { default: 'app-light', other: 'app-dark' };
const defaultTheme = options.default;
const otherTheme = options.other;

// --- Cookie helpers ---
function setCookie(name: string, value: string, days: number = 365): void {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
}

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}
// ---

// --- Toggle event listener ---
themeControllerInputs.forEach((input) => {
  input.addEventListener('change', () => {
    const newTheme = input.checked ? otherTheme : defaultTheme;

    // Update storage & document
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    setCookie('theme', newTheme); // <-- Also set the cookie
  });
});

// --- Initial sync (fallback, runs after DOM is ready) ---
document.addEventListener('DOMContentLoaded', () => {
  // Read from localStorage first, fallback to cookie
  let theme = localStorage.getItem('theme') || getCookie('theme');

  // If nothing is stored, use the default
  if (!theme) {
    theme = defaultTheme;
  }

  // Ensure the HTML attribute matches (server should already do this, but good for safety)
  document.documentElement.setAttribute('data-theme', theme!);

  // Sync all toggle checkboxes
  const isDark = theme === otherTheme;
  themeControllerInputs.forEach((input) => {
    input.checked = isDark;
  });
});
